import { useEffect } from 'react';
import { useSettings } from '@/context/SettingsContext';

const DEFAULT_FAVICON = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='14' fill='%23d99f1c'/%3E%3Ctext x='32' y='46' text-anchor='middle' font-family='system-ui,sans-serif' font-size='36' font-weight='700' fill='white'%3EC%3C/text%3E%3C/svg%3E`;

export default function DynamicFavicon() {
  const { settings } = useSettings();

  useEffect(() => {
    const href = settings.general.favicon_url || DEFAULT_FAVICON;
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (link.href !== href) {
      link.href = href;
    }
  }, [settings.general.favicon_url]);

  return null;
}